import { Button, DropdownMenu, Box, Flex, Tooltip, Text, TextField } from '@radix-ui/themes';
import StarOutlineOutlinedIcon from '@mui/icons-material/StarOutlineOutlined';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import { FolderIcon, HelpOutlineIcon } from 'shared/icons';
import ApiKey from 'Components/api/ApiKey';
import Cookies from 'js-cookie';
import { FavFolder, useGetFavoriteFolderList } from './useGetFavoritesFolder';
import { useState } from 'react';
import { cx } from 'class-variance-authority';

import './add-to-favorites.scss';
import { useCreateFavFolder } from './useCreateFavFolder';
import { FormField } from 'shared/components';
import { useAddToFavorite } from './useAddToFavorite';
import { SimpleCv } from '../types';

export function AddToFavorites({ simpleCv }: { simpleCv: SimpleCv }) {
   const tokenKey = Cookies.get('tokenClient');
   const apiKey = ApiKey;
   const [showCreateFolderInput, setShowCreateFolderInput] = useState(false);

   const [selectedFolder, setSelectedFolder] = useState<FavFolder | null>(null);

   const { foldersList, getFoldersList } = useGetFavoriteFolderList({
      token: tokenKey ?? '',
      apiKey,
   });

   const { onCreateFolder, createFolderLoading, folderName, setFolderName } = useCreateFavFolder({
      token: tokenKey ?? '',
      apiKey,
      onSuccess: () => {
         getFoldersList();
         setShowCreateFolderInput(false);
      },
   });

   const { onAddFavorite } = useAddToFavorite(
      {
         selectedFolderId: selectedFolder?.id,
         from_cv_database: null,
         type: 'simple',
      },
      {
         cvId: simpleCv.id,
         candidateId: simpleCv.user_id,
      },
      {
         apiKey,
         token: tokenKey ?? '',
      }
   );

   return (
      <DropdownMenu.Root>
         <DropdownMenu.Trigger>
            <Button size="4" radius="small">
               <StarOutlineOutlinedIcon />
               Додати до обраних
            </Button>
         </DropdownMenu.Trigger>

         <DropdownMenu.Content className="add-to-favorites-dropdown">
            <Box className="add-to-favorites-dropdown__content">
               <Flex gap="1" direction="column" mb="5">
                  {foldersList.map((favFolder) => {
                     return (
                        <div
                           key={favFolder.id}
                           className={cx(
                              'fav-folder',
                              selectedFolder?.id === favFolder.id && 'fav-folder--selected'
                           )}
                           onClick={() => {
                              setSelectedFolder(favFolder);
                           }}
                        >
                           {favFolder.name}
                           <span>
                              <FolderIcon color="#84a1ce93" />
                           </span>
                        </div>
                     );
                  })}
               </Flex>

               <Flex gap="1" mb="5">
                  <Button
                     size="3"
                     onClick={() => {
                        onAddFavorite();
                     }}
                     disabled={!selectedFolder}
                     color="blue"
                  >
                     Додати до обраних
                  </Button>

                  {!selectedFolder && (
                     <Tooltip content="Щоб додати оберіть папку">
                        <Text color="gray">
                           <HelpOutlineIcon width={18} height={18} />
                        </Text>
                     </Tooltip>
                  )}
               </Flex>

               <DropdownMenu.Separator />
               <Flex pt="3" width="100%" direction="column" align="start" gap="3">
                  {showCreateFolderInput && (
                     <FormField label="">
                        <TextField.Root
                           value={folderName}
                           onChange={(e) => {
                              setFolderName(e.target.value);
                           }}
                           placeholder="Назва папки"
                        />
                     </FormField>
                  )}

                  <Button
                     ml="2"
                     variant="ghost"
                     size="2"
                     disabled={!folderName && showCreateFolderInput}
                     onClick={() => {
                        if (showCreateFolderInput) {
                           onCreateFolder();
                        } else {
                           setShowCreateFolderInput(true);
                        }
                     }}
                     loading={createFolderLoading}
                  >
                     {!showCreateFolderInput && <CreateNewFolderIcon />}
                     Створити папку
                  </Button>
               </Flex>
            </Box>
         </DropdownMenu.Content>
      </DropdownMenu.Root>
   );
}
